import axios from 'axios'
import { url } from '../../api/url'
import { HeadersWithCredentials } from '../../api/header'

export const FindPlanning = async (eventIdentifier) => {
    return await axios.get(`${url}/planning/${eventIdentifier}`, {
        headers: HeadersWithCredentials(),
    })
}

export const FindPlanningHidePrivateData = async (eventIdentifier) => {
    return await axios.get(`${url}/planning/${eventIdentifier}/hidePrivateData`, {
        headers: HeadersWithCredentials(),
    })
}

export const updatePlanning = async (competitionId, body) => {
    return await axios.patch(`${url}/planning/${competitionId}`, body, {
        headers: HeadersWithCredentials(),
    })
}

export const IsPublished = async (eventIdentifier) => {
    return await axios.get(`${url}/planning/is-published/${eventIdentifier}`, {
        headers: HeadersWithCredentials(),
    })
}

export const toggleHideJudges = async (competitionId, value) => {
    return await axios.put(
        `${url}/planning/toggle-hide-judges/${competitionId}`,
        { value },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const getTvConfig = async (eventIdentifier) => {
    return await axios.get(`${url}/planning/stream-config/${eventIdentifier}`, {
        headers: HeadersWithCredentials(),
    })
}

export const updateTvConfig = async (competitionId, tvConfig) => {
    return await axios.put(
        `${url}/planning/stream-config/${competitionId}`,
        { tvConfig },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const deleteTvConfig = async (competitionId, tvConfigId) => {
    return await axios.delete(`${url}/planning/stream-config/${competitionId}/${tvConfigId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const getTvInfo = async (eventIdentifier, tvIndex, lastPlanningUpdatedAt) => {
    return await axios.get(`${url}/planning/stream/${eventIdentifier}/${tvIndex}`, {
        params: { lastPlanningUpdatedAt },
        headers: HeadersWithCredentials(),
    })
}
